import { render, staticRenderFns } from "./IssueView.vue?vue&type=template&id=200851d9&"
import script from "./IssueView.vue?vue&type=script&lang=js&"
export * from "./IssueView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports